import './style.scss';

export function contact_us_block() {
    const block = document.querySelector('.contact_us_block');
    if (!block) return;

}
